import styled from "styled-components";
// import { Link } from "react-router-dom";
import CPLogo from "../images/crowdplat.jpg"
import LanguageSwitcher from "./LanguageSwitcher";
// import { useNavigate } from "react-router-dom";

const NavBar = () => {
    // const navigate = useNavigate();
  return (
    <NavBarWrap>
        <Nav>
        <Links>
        <li>
            {/* <Link to="/"> */}
          <img alt="logo" src={CPLogo} width="600" height="129" />
        {/* </Link> */}
        </li>
           </Links>
        <LanguageSwitcher />
        </Nav>
    </NavBarWrap>
  );
};
// #1565C0;
const NavBarWrap = styled.div`
background-color:  #2E7D32;
height: 100%;
align-content: center;
font-size: 1.25rem;
color: #FFFFFF;
padding: 20px 0 15px;
img{
    width: 200px;
    height: auto;
}
a{
        text-decoration: none;
  color: inherit;
    }
`;

const Nav = styled.nav`
display: flex;
justify-content: space-between;
align-items: center;
margin-right: 40px;
`;

const Links = styled.ul`
    list-style-type: none;
    display: flex;
    align-items: center;
    margin: 0;
    li{
        margin-right: 50px;
        justify-items: center;
    }
    .link-wrap{
        margin: 20px 0;
    }
    .line{
        width: 150px;
        height: 3px;
        background-color: #1565C0;
    }
    .activeTab{
        background-color: white;
    }
   
`;

export default NavBar;